<div class="main-content">
  <app-header [title]="(isEdit ? 'LEARNING_FORM.EDIT_TITLE' : 'LEARNING_FORM.CREATE_TITLE') | translate" />

  <div class="d-flex justify-content-center flex-fill">
    <div class="col-10 d-flex flex-column align-items-center">
      @if (isAdmin) {
        <div class="admin-actions w-100 flex-fill d-flex flex-row justify-content-end align-items-center gap-2">
          <button class="delete" (click)="onDelete()" [disabled]="isDeleting">
            @if (isDeleting) {
              <div class="d-flex align-items-center justify-content-center gap-2">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span>{{ 'LEARNING.DELETING' | translate }}</span>
              </div>
            } @else {
              {{ 'LEARNING.DELETE' | translate }}
            }
          </button>
          <button class="edit" (click)="goToForm()">{{ 'LEARNING.EDIT' | translate }}</button>
        </div>
      }

      @if (isLoading) {
        <div class="text-center py-5">{{ 'LEARNING.LOADING_IN_PROGRESS' | translate }}</div>
      }

      @if (!isLoading) {
        @if (learning) {
          <div class="detail-container">
            <div class="learning-detail-header">
              <span class="subtitle">{{ learning.createdDate ? (learning.createdDate | date: 'd MMMM y') : '' }}</span>
              <h1 class="title">{{ learning.title }}</h1>
            </div>
            <div class="infos-container">
              <div class="d-flex flex-column flex-fill w-100">
                <div class="d-flex flex-row gap-2 flex-fill">
                  <span>{{ 'LEARNING.MACHINE' | translate }}</span>
                  <span class="fw-bold">
                    {{ learning.machineTypes && learning.machineTypes.length ? learning.machineTypes.join(', ') : '-' }}
                  </span>
                </div>
                <div class="d-flex flex-row gap-2 flex-fill">
                  <span>{{ 'LEARNING.LEVEL' | translate }}</span>
                  <span class="fw-bold">{{ learning.complexity || '-' }}</span>
                </div>
                @if (learning.tags && learning.tags.length > 0) {
                  <div class="d-flex flex-row gap-2 flex-fill">
                    <span>{{ 'LEARNING.TAGS' | translate }}</span>
                    <span class="fw-bold">{{ getFormattedTags(learning) }}</span>
                  </div>
                }
              </div>
              <button
                class="learning-detail-favorite-button"
                [ngClass]="isFavorite ? 'favorite' : 'add-to-favorite'"
                (click)="toggleFavoriteAction()"
                [disabled]="isTogglingFavorite"
                [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
              >
                @if (isTogglingFavorite) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                  </div>
                } @else {
                  {{ (isFavorite ? 'LEARNING.REMOVE_FROM_FAVORITES' : 'LEARNING.ADD_TO_FAVORITES') | translate }}
                }
              </button>
            </div>
            @if (
              (!isLoadingVideos && videoAttachments.length > 0) ||
              (!isLoadingImages && imageAttachments.length > 0) ||
              (!isLoadingDocuments && documentAttachments.length > 0)
            ) {
              <div class="attachments-section">
                @if (showAttachmentTabs) {
                  <div class="tabs-container">
                    <div class="tabs-wrapper">
                      @if (!isLoadingVideos && videoAttachments.length > 0) {
                        <button
                          class="tab-button"
                          [ngClass]="{ active: selectedAttachmentTab === 0 }"
                          (click)="switchAttachmentTab(0)"
                        >
                          <div class="d-flex align-items-center gap-2 align-self-stretch">
                            <img
                              class="icons"
                              alt=""
                              [src]="
                                selectedAttachmentTab === 0
                                  ? '../assets/icon/article-white.svg'
                                  : '../assets/icon/article-dark.svg'
                              "
                            />
                            <span class="tab-text">{{ 'FILE_INPUT_HISTORY.VIDEO' | translate }}</span>
                          </div>
                          @if (selectedAttachmentTab === 0) {
                            <div class="tab-arrow">
                              <app-icam-icon iconName="chevron-down" [iconHeight]="'10px'" />
                            </div>
                          }
                        </button>
                      }
                      @if (!isLoadingImages && imageAttachments.length > 0) {
                        <button
                          class="tab-button"
                          [ngClass]="{ active: selectedAttachmentTab === 1 }"
                          (click)="switchAttachmentTab(1)"
                        >
                          <div class="d-flex align-items-center gap-2 align-self-stretch">
                            <img
                              class="icons"
                              alt=""
                              [src]="
                                selectedAttachmentTab === 1
                                  ? '../assets/icon/picture-white.svg'
                                  : '../assets/icon/picture-dark.svg'
                              "
                            />
                            <span class="tab-text">{{ 'FILE_INPUT_HISTORY.IMAGES' | translate }}</span>
                          </div>
                          @if (selectedAttachmentTab === 1) {
                            <div class="tab-arrow">
                              <app-icam-icon iconName="chevron-down" [iconHeight]="'10px'" />
                            </div>
                          }
                        </button>
                      }
                      @if (!isLoadingDocuments && documentAttachments.length > 0) {
                        <button
                          class="tab-button"
                          [ngClass]="{ active: selectedAttachmentTab === 2 }"
                          (click)="switchAttachmentTab(2)"
                        >
                          <div class="d-flex align-items-center gap-2 align-self-stretch">
                            <img
                              alt=""
                              class="icons"
                              [src]="
                                selectedAttachmentTab === 2
                                  ? '../assets/icon/article-white.svg'
                                  : '../assets/icon/article-dark.svg'
                              "
                            />
                            <span class="tab-text">{{ 'FILE_INPUT_HISTORY.DOCUMENTS' | translate }}</span>
                          </div>
                          @if (selectedAttachmentTab === 2) {
                            <div class="tab-arrow">
                              <app-icam-icon iconName="chevron-down" [iconHeight]="'10px'" />
                            </div>
                          }
                        </button>
                      }
                    </div>
                  </div>
                }
                @if (selectedAttachmentTab === 0 && !isLoadingVideos && videoAttachments.length > 0) {
                  <div class="tab-content video-tab">
                    <div class="media-grid video-grid">
                      @for (video of videoAttachments; track video; let i = $index) {
                        <div class="media-item">
                          <div class="media-preview">
                            @if (video.filePath) {
                              <div class="video-clickable">
                                <div
                                  class="preview-wrapper"
                                  role="button"
                                  (click)="openVideoFullscreen(video.filePath, video.fileName)"
                                  (keydown.enter)="openVideoFullscreen(video.filePath, video.fileName)"
                                  tabindex="0"
                                >
                                  <app-video-player
                                    class="preview-player"
                                    [videoUrl]="video.filePath!"
                                    [videoTitle]="video.fileName || ''"
                                    [controls]="false"
                                    [autoplay]="false"
                                    [muted]="true"
                                    [preload]="'metadata'"
                                    [width]="'100%'"
                                  >
                                  </app-video-player>
                                  <div class="video-overlay-play">
                                    <app-icam-icon iconName="play-light" [iconHeight]="'36px'"></app-icam-icon>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!video.filePath) {
                              <div class="video-error-placeholder">
                                <p class="error-message">{{ 'LEARNING.VIDEO_ERROR_MESSAGE' | translate }}</p>
                                <p class="error-filename">
                                  {{ video.fileName || ('LEARNING.VIDEO_NOT_AVAILABLE' | translate) }}
                                </p>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (selectedAttachmentTab === 1 && !isLoadingImages && imageAttachments.length > 0) {
                  <div class="tab-content">
                    <div class="media-grid image-grid">
                      @for (image of imageAttachments; track image; let i = $index) {
                        <div class="media-item">
                          <div class="media-preview">
                            <div
                              class="image-container"
                              role="button"
                              (click)="openImageFullscreen(image.filePath)"
                              (keydown.enter)="openImageFullscreen(image.filePath)"
                              tabindex="0"
                            >
                              <div class="image-opacity"></div>
                              @if (image.filePath) {
                                <img [src]="image.filePath" [alt]="image.fileName || 'Image'" class="grid-image" />
                              }
                            </div>
                            @if (!image.filePath) {
                              <div class="image-error-placeholder">
                                <p class="error-message">{{ 'LEARNING.IMAGE_ERROR_MESSAGE' | translate }}</p>
                                <p class="error-filename">
                                  {{ image.fileName || ('LEARNING.IMAGE_NOT_AVAILABLE' | translate) }}
                                </p>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (selectedAttachmentTab === 2 && !isLoadingDocuments && documentAttachments.length > 0) {
                  <div class="tab-content">
                    <div class="documents-list">
                      @for (document of documentAttachments; track document) {
                        <div class="document-item">
                          <div class="document-name">
                            <span>{{ 'FILE_DOWNLOADER.FILE_NAME' | translate }}</span>
                            <span>{{ document.fileName || 'Document' }}</span>
                          </div>
                          <button
                            class="document-download-btn"
                            (click)="downloadDocument(document.attachmentId || document.id, document.fileName)"
                            [attr.aria-label]="'Download ' + (document.fileName || 'document')"
                          >
                            {{ 'FILE_DOWNLOADER.DOWNLOAD' | translate }}
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (isLoadingVideos || isLoadingImages || isLoadingDocuments) {
              <div class="text-center py-3">
                {{ 'LEARNING.LOADING_IN_PROGRESS' | translate }}
              </div>
            }
            <app-raw-html [html]="backendHtml"></app-raw-html>
          </div>
        } @else {
          <div class="text-center py-5">{{ 'LEARNING.NO_CONTENT_AVAILABLE' | translate }}</div>
        }
        <button class="button-send-feedback" (click)="goToFeedbackForm()">INVIA FEEDBACK</button>
      }
    </div>
  </div>
  <div class="col-10">
    <div class="form-footer d-flex justify-content-between mt-4">
      <div>
        <app-back-button
          class="app-back-button"
          [linkText]="'LEARNING_FORM.BACK_TO_LEARNINGS'"
          (click)="goBack()"
        ></app-back-button>
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
